import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.duplicateQuestion.loading;
export const duplicateQuestionErrorMessage = (state: RootState) =>
  state.duplicateQuestion.error;
export const duplicateQuestionResponseData = (state: RootState) =>
  state.duplicateQuestion.duplicateQuestionResponse;
